import { useState } from "react";
import Appraisal from "../components/clinicalEval/Appraisal";
import AppraisalGrading from "../components/clinicalEval/AppraisalGrading";
import Claims from "../components/clinicalEval/Claims";
import Literatures from "../components/clinicalEval/literatures";
import Planning from "../components/clinicalEval/Planning";
import ProductConcept from "../components/clinicalEval/ProductConcept";
import SearchEval from "../components/clinicalEval/SearchEval";
import Summary from "../components/clinicalEval/Summary";
import ContentTitle from "../layout/ContentTitle";

const ClinicalEval = () => {
  const [activeTab, setActiveTab] = useState("concept");
  const tabs = [
    {
      id: "concept",
      label: "Product Concept",
      content: (props) => <ProductConcept {...props} />,
    },
    {
      id: "planning",
      label: "Planning",
      content: (props) => <Planning {...props} />,
    },
    {
      id: "search",
      label: "Search & Evaluate",
      content: (props) => <SearchEval {...props} />,
    },
    {
      id: "literatures",
      label: "Relevant Literatures",
      content: (props) => <Literatures {...props} />,
    },
    {
      id: "grading",
      label: "Appraisal Grading System",
      content: (props) => <AppraisalGrading {...props} />,
    },
    {
      id: "appraisal",
      label: "Appraisal",
      content: (props) => <Appraisal {...props} />,
    },
    {
      id: "claims",
      label: "Claims",
      content: (props) => <Claims {...props} />,
    },
    // {
    //   id: "deep-analysis",
    //   label: "Deep Analysis",
    //   content: (props) => <DeepAnalysis {...props} />,
    // },
    {
      id: "summary",
      label: "Summary",
      content: (props) => <Summary {...props} />,
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  const goToNextTab = () => {
    const currentIdx = tabs.findIndex((tab) => tab.id === activeTab);
    if (currentIdx < tabs.length - 1) {
      const nextTabId = tabs[currentIdx + 1].id;
      setActiveTab(nextTabId);
    }
  };

  return (
    <div className="flex h-[calc(100vh-40px)] w-full flex-col">
      <ContentTitle title={"Clinical Literature Review"} />

      <div className="tabs tabs-boxed mt-4 ml-3">
        {tabs.map((tab, idx) => {
          // const isVisited = visitedTabs.includes(tab.id);
          const isVisited = true;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => isVisited && handleTabClick(tab.id)}
              disabled={!isVisited}
              className={`
              tab relative mb-1 -ml-2 overflow-visible pl-6
              text-sm md:text-base tracking-wide
              transition-all duration-300 ease-in-out
              ${isActive
                  ? `
                    tab-active
                    bg-primary/70
                    scale-105
                    font-bold
                    border border-gray-300
                    text-white
                    shadow-md
                    hover:text-white
                    dark:border-gray-600
                    dark:bg-gray-700
                    dark:text-white
                  `
                  : isVisited
                    ? `
                      font-medium
                      text-base-content
                      opacity-90
                      border border-gray-300
                      bg-base-200
                      hover:opacity-100
                      dark:bg-base-300
                    `
                    : `
                      cursor-not-allowed
                      font-medium
                      text-base-content
                      opacity-60
                      hover:bg-base-200
                      dark:hover:bg-base-300
                    `
                }
            `}
              style={{
                clipPath:
                  idx === 0
                    ? "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%)"
                    : "polygon(0 0, calc(100% - 16px) 0, 100% 50%, calc(100% - 16px) 100%, 0 100%, 30px 0, 30px 100%)",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div className="card bg-base-100 mt-1 flex flex-1 flex-col overflow-hidden p-1 shadow-xl">
        {tabs.find((tab) => tab.id === activeTab)?.content({ goToNextTab })}
      </div>
    </div>
  );
};

export default ClinicalEval;
